import { Box, Table, Sheet, Chip } from "@mui/joy";
import DarkCard from "../../common/DarkCard";
import DarkTypography from "../../common/DarkTypography";
import { SComment } from "../../../styles/StyledMUI";
import type { LeaveType, UserLeaveTypeBalance } from "../../../api/leave/Leave.typed";
import {
  ctaAccentColor,
  hrCommentCountChipSx,
  hrSheetSx,
  hrTableSx,
} from "../../../styles/globalStyles";

export type LeaveManagementBalancesCardProps = {
  userBalances: UserLeaveTypeBalance[];
  typesById: Record<number, LeaveType>;
  onOpenComments: (typeId: number) => void;
};

export default function LeaveManagementBalancesCard({
  userBalances,
  typesById,
  onOpenComments,
}: LeaveManagementBalancesCardProps) {
  return (
    <DarkCard sx={{ mb: 2 }}>
      <DarkTypography level="title-md" colorVariant="accent" sx={{ mb: 1 }}>
        Mes compteurs
      </DarkTypography>
      {/* if no balances or no balances with uses counter, show a message */}
      {userBalances.length === 0 || !userBalances.some((b) => typesById[b.TypeID]?.UsesCounter) ? (
        <DarkTypography level="body-sm" colorVariant="muted">
          Aucun compteur associé.
        </DarkTypography>
      ) : (
        <Sheet sx={{ ...hrSheetSx, borderRadius: "6px" }}>
          <Table size="sm" sx={hrTableSx}>
            <thead>
              <tr>
                <th>Type</th>
                <th>Solde</th>
                <th>MAJ</th>
                <th>Commentaires</th>
              </tr>
            </thead>
            <tbody>
              {userBalances
                .filter((b) => !!typesById[b.TypeID]?.UsesCounter)
                .map((b) => (
                  <tr key={`${b.TypeID}-${b.UserID}`}>
                    <td>
                      <DarkTypography level="body-sm">
                        {typesById[b.TypeID]?.Name ?? `Type #${b.TypeID}`}
                      </DarkTypography>
                    </td>
                    <td>
                      <DarkTypography level="body-sm" sx={{ fontWeight: "bold" }}>
                        {b.Balance}
                      </DarkTypography>
                    </td>
                    <td>
                      <DarkTypography level="body-xs" colorVariant="muted">
                        {new Date(b.UpdatedAt).toLocaleDateString("fr-FR")}
                      </DarkTypography>
                    </td>
                    <td>
                      <Box
                        sx={{ display: "inline-flex", alignItems: "center", gap: 0.75 }}
                        onClick={() => onOpenComments(b.TypeID)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => e.key === "Enter" && onOpenComments(b.TypeID)}
                      >
                        <SComment iconColor={ctaAccentColor} />
                        <Chip size="sm" variant="soft" color="neutral" sx={hrCommentCountChipSx}>
                          {Array.isArray(b.MultiComments) ? b.MultiComments.length : 0}
                        </Chip>
                      </Box>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </Sheet>
      )}
    </DarkCard>
  );
}
